export default "__VITE_ASSET__1eee82b2__"